<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
            >×
            </span>
          </button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table">
              <tr>
                <th>
                  {{ "name" | translate }}
                </th>
                <th>
                  {{ "value" | translate }}
                </th>
              </tr>
              <tr>
                <td>
                  {{ "valid_from" | translate }}:
                </td>
                <td>
                  <datepicker
                    :typeable=true
                    v-validate="{required: true}"
                    input-class="form-control pepe"
                    key="valid_from"
                    name="valid_from"
                    @input="selectedDate()"
                    @
                    format="dd.MM.yyyy"
                    calendar-class="datepicker"
                    v-model="validFromValue"
                  />
                  <span
                    v-if="this.valid_from_error.length > 0"
                    class="small text-danger"
                  >
                   {{ this.valid_from_error | translate }}
                  </span>
                </td>
              </tr>

              <tr>
                <td>
                  {{ "creditorNo" | translate }}:
                </td>
                <td>
                  <input
                    v-if="creditorNo === ''"
                    @keyup="creditorValueKeyUp()"
                    type="text"
                    v-validate="{ regex: /^\d{10}$/ }"
                    name="creditNoN" key="creditNoN" class="form-control"
                    v-model="creditorNoValue"
                  />
                  <span
                    v-show="errors.has('creditNoN')"
                    v-if="!creditorNo"
                    class="small text-danger"
                  >
                    {{ 'this_field_required_10_numbers' | translate }}
                  </span>
                  <input
                    v-else @keyup="creditorKeyUp()"
                    type="text"
                    v-validate="{ regex: /^\d{10}$/ }"
                    name="creditNo"
                    class="form-control"
                    key="creditNo"
                    v-model="creditorNo"
                  />
                  <span
                    v-show="errors.has('creditNo')"
                    v-else-if="creditorNo"
                    class="small text-danger"
                  >
                    {{ 'this_field_required_10_numbers' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ 'company' | translate }}:
                </td>
                <td>
                  <label>
                    {{ company_name }}
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "sales_channel" | translate }}:
                </td>
                <td>
                  <select
                    v-validate="{required: true}"
                    name="sales_channel_id"
                    key="sales_channel_id"
                    class="form-control"
                    @change="setType()"
                    v-model="fee.sales_channel_id"
                  >
                    <option
                      class="normal"
                      v-for="(name,id) in salesChannels" :value="id"
                    >
                      {{ name | translate }}
                    </option>
                  </select>
                  <span
                    v-show="errors.has('sales_channel_id')"
                    class="small text-danger"
                  >
                    {{ 'this_field_required' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "order_type" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    readonly
                    class="form-control"
                    name="order_type"
                    v-model="fee.order_type"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {{ "country" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    v-validate="{ regex: /^[A-Z]{2}$/, required: true  }"
                    class="form-control"
                    name="country"
                    @keyup="setType()"
                    v-model="fee.country"/>
                  <span
                    v-show="errors.has('country')"
                    class="small text-danger"
                  >
                  {{ 'country_validation' | translate }}
                </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "type" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    name="type"
                    class="form-control"
                    readonly
                    v-model="fee.type "
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {{ "mp_costs_step_1" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    v-show="fee.type !=='Zalando' && fee.type !=='Selfservice_schuhede' && fee.type !=='Sport2000' && fee.type !=='Ats_de'"
                    readonly
                    name="mp_costs_step_1"
                    key="mp_costs_step_1"
                    class="form-control"
                    v-model="fee.mp_costs_step_1"
                  />
                  <input
                    type="text"
                    v-show="fee.type ==='Zalando' || fee.type ==='Selfservice_schuhede' || fee.type ==='Sport2000' || fee.type ==='Ats_de'"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type === 'Zalando' || fee.type ==='Selfservice_schuhede' || fee.type ==='Sport2000' || fee.type ==='Ats_de'}"
                    name="mp_costs_step_1"
                    key="mp_costs_step_1_1"
                    class="form-control"
                    v-model="fee.mp_costs_step_1"
                  />
                  <span
                    v-show="errors.has('mp_costs_step_1')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "mp_costs_step_2" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    v-show="fee.type !=='Zalando' && fee.type !=='Selfservice_schuhede' && fee.type !=='Sport2000' && fee.type !=='Ats_de'"
                    readonly
                    name="mp_costs_step_2"
                    class="form-control"
                    key="mp_costs_step_2"
                    v-model="fee.mp_costs_step_2"
                  />
                  <input
                    type="text"
                    v-show="fee.type ==='Zalando' || fee.type ==='Selfservice_schuhede' || fee.type ==='Sport2000' || fee.type ==='Ats_de'"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type === 'Zalando'  || fee.type ==='Selfservice_schuhede' || fee.type ==='Sport2000' || fee.type ==='Ats_de'}"
                    name="mp_costs_step_2"
                    key="mp_costs_step_2_1"
                    class="form-control"
                    v-model="fee.mp_costs_step_2"
                  />
                  <span
                    v-show="errors.has('mp_costs_step_2')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "mp_costs_step_3" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    v-show="fee.type !=='Zalando' && fee.type !=='Selfservice_schuhede' && fee.type !=='Sport2000' && fee.type !=='Ats_de'"
                    readonly key="mp_costs_step_3"
                    name="mp_costs_step_3"
                    class="form-control"
                    v-model="fee.mp_costs_step_3"
                  />
                  <input
                    type="text" v-show="fee.type ==='Zalando' || fee.type ==='Selfservice_schuhede' || fee.type ==='Sport2000' || fee.type ==='Ats_de'"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type === 'Zalando'  || fee.type ==='Selfservice_schuhede' || fee.type ==='Sport2000' || fee.type ==='Ats_de'}"
                    name="mp_costs_step_3"
                    key="mp_costs_step_3_1"
                    class="form-control"
                    v-model="fee.mp_costs_step_3"
                  />
                  <span
                    v-show="errors.has('mp_costs_step_3')"
                    class="small text-danger">
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "mp_costs_step_4" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    v-show="fee.type !=='Zalando' && fee.type !=='Selfservice_schuhede' && fee.type !=='Sport2000' && fee.type !=='Ats_de'"
                    readonly
                    name="mp_costs_step_4"
                    class="form-control"
                    key="mp_costs_step_4"
                    v-model="fee.mp_costs_step_4"
                  />
                  <input
                    type="text"
                    v-show="fee.type ==='Zalando' || fee.type ==='Selfservice_schuhede' || fee.type ==='Sport2000' || fee.type ==='Ats_de'"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type === 'Zalando'  || fee.type ==='Selfservice_schuhede' || fee.type ==='Sport2000' || fee.type ==='Ats_de'}"
                    name="mp_costs_step_4"
                    key="mp_costs_step_4_1"
                    class="form-control"
                    v-model="fee.mp_costs_step_4"
                  />
                  <span
                    v-show="errors.has('mp_costs_step_4')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "mp_costs_step_default" | translate }}:
                </td>
                <td>
                  <input
                    v-show="fee.type !=='Zalando' && fee.type !=='Selfservice_schuhede' && fee.type !=='Sport2000' && fee.type !=='Ats_de'"
                    @keyup="setOtherMps()"
                    type="text"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type !== 'Zalando'  && fee.type !=='Selfservice_schuhede' && fee.type !=='Sport2000' && fee.type !=='Ats_de'}"
                    name="mp_costs_step_default"
                    key="mp_costs_step_default"
                    class="form-control"
                    v-model="fee.mp_costs_step_default"
                  />
                  <input
                    v-show="fee.type ==='Zalando' || fee.type ==='Selfservice_schuhede' || fee.type ==='Sport2000' || fee.type ==='Ats_de'"
                    readonly
                    type="text"
                    name="mp_costs_step_default"
                    key="mp_costs_step_default_1"
                    class="form-control"
                    v-model="fee.mp_costs_step_default"
                  />
                  <span
                    v-show="errors.has('mp_costs_step_default')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "anwr_trans_costs_step_1" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    v-show="fee.type ==='Legero' || this.fee.type === 'Tamaris' || this.fee.type === 'Marco_tozzi'"
                    readonly
                    name="anwr_trans_costs_step_1"
                    class="form-control"
                    key="anwr_trans_costs_step_1"
                    v-model="fee.anwr_trans_costs_step_1"
                  />
                  <input
                    type="text"
                    v-show="fee.type !=='Legero' && this.fee.type !== 'Tamaris' || this.fee.type === 'Marco_tozzi'"
                    key="anwr_trans_costs_step_1_1"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type !=='Legero' && this.fee.type !== 'Tamaris' }"
                    name="anwr_trans_costs_step_1"
                    class="form-control"
                    v-model="fee.anwr_trans_costs_step_1"
                  />
                  <span
                    v-show="errors.has('anwr_trans_costs_step_1')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "anwr_trans_costs_step_2" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    v-show="fee.type ==='Legero' || this.fee.type === 'Tamaris'"
                    readonly
                    name="anwr_trans_costs_step_2"
                    key="anwr_trans_costs_step_2"
                    class="form-control"
                    v-model="fee.anwr_trans_costs_step_2"
                  />
                  <input
                    type="text"
                    v-show="fee.type !=='Legero' && this.fee.type !== 'Tamaris'"
                    key="anwr_trans_costs_step_2_1"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type !=='Legero' && this.fee.type !== 'Tamaris' }"
                    name="anwr_trans_costs_step_2"
                    class="form-control"
                    v-model="fee.anwr_trans_costs_step_2"
                  />
                  <span
                    v-show="errors.has('anwr_trans_costs_step_2')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "anwr_return_costs_step_1" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    v-show="fee.type ==='Legero' || this.fee.type === 'Tamaris'"
                    readonly
                    key="anwr_return_costs_step_1"
                    class="form-control"
                    name="anwr_return_costs_step_1"
                    v-model="fee.anwr_return_costs_step_1"/>
                  <input
                    type="text" v-show="fee.type !=='Legero' && this.fee.type !== 'Tamaris'"
                    key="anwr_return_costs_step_1_1"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type !=='Legero' && this.fee.type !== 'Tamaris' }"
                    class="form-control"
                    name="anwr_return_costs_step_1"
                    v-model="fee.anwr_return_costs_step_1"
                  />
                  <span
                    v-show="errors.has('anwr_return_costs_step_1')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "anwr_return_costs_step_2" | translate }}:
                </td>
                <td>
                  <input
                    type="text"
                    v-show="fee.type ==='Legero' || this.fee.type === 'Tamaris'"
                    readonly
                    name="anwr_return_costs_step_2"
                    key="anwr_return_costs_step_2"
                    class="form-control"
                    v-model="fee.anwr_return_costs_step_2"
                  />
                  <input
                    type="text"
                    v-show="fee.type !=='Legero' && this.fee.type !== 'Tamaris'"
                    key="anwr_return_costs_step_2_1"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type !=='Legero' && this.fee.type !== 'Tamaris' }"
                    name="anwr_return_costs_step_2"
                    class="form-control"
                    v-model="fee.anwr_return_costs_step_2"
                  />
                  <span
                    v-show="errors.has('anwr_return_costs_step_2')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "mp_return_costs" | translate }}:
                </td>
                <td>
                  <input
                    v-show="fee.type !=='Amazon'"
                    readonly
                    type="text"
                    class="form-control"
                    name="mp_return_costs"
                    key="mp_return_costs"
                    v-model="fee.mp_return_costs"
                  />
                  <input
                    v-show="fee.type === 'Amazon'"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type === 'Amazon' }"
                    type="text"
                    class="form-control"
                    key="mp_return_costs_1"
                    name="mp_return_costs"
                    v-model="fee.mp_return_costs"
                  />
                  <span
                    v-show="errors.has('mp_return_costs')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "mp_return_costs_max" | translate }}:
                </td>
                <td>
                  <input
                    v-show="fee.type !=='Amazon'"
                    readonly
                    type="text"
                    name="mp_return_costs_max"
                    class="form-control"
                    key="mp_return_costs_max"
                    v-model="fee.mp_return_costs_max"
                  />
                  <input
                    v-show="fee.type === 'Amazon'"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type === 'Amazon' }"
                    key="mp_return_costs_max_1"
                    type="text"
                    name="mp_return_costs_max"
                    class="form-control"
                    v-model="fee.mp_return_costs_max"
                  />
                  <span
                    v-show="errors.has('mp_return_costs_max')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "mp_payment_costs" | translate }}:
                </td>
                <td>
                  <input
                    v-show="fee.type ==='Ebay'"
                    v-validate="{ regex: /^(\d+(?:[\.\,]\d{0,10})?)$/, required: fee.type === 'Ebay' }"
                    type="text"
                    key="mp_payment_costs"
                    name="mp_payment_costs"
                    class="form-control"
                    v-model="fee.mp_payment_costs"
                  />
                  <input
                    v-show="fee.type !=='Ebay'"
                    key="mp_payment_costs_1"
                    readonly
                    type="text"
                    name="mp_payment_costs"
                    class="form-control"
                    v-model="fee.mp_payment_costs"
                  />
                  <span
                    v-show="errors.has('mp_payment_costs')"
                    class="small text-danger"
                  >
                    {{ 'this_field_must_be_number' | translate }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ "commentary" | translate }}
                </td>
                <td>
                  <textarea type="textarea"
                            class="form-control"
                            v-model="fee.comment"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <div class="col-xs-12">
            <button
              class="btn btn-danger"
              data-dismiss="modal"
              @click="$emit('modalClicked','')"
              id="buttonCancel"
            >
              {{ 'cancel' | translate }}
            </button>
            <button
              :disabled="errors.has('mp_payment_costs') ||
              errors.has('mp_return_costs_max') ||
              errors.has('mp_return_costs') ||
              errors.has('anwr_return_costs_step_2') ||
              errors.has('anwr_return_costs_step_1') ||
              errors.has('anwr_trans_costs_step_2') ||
              errors.has('anwr_trans_costs_step_1') ||
              errors.has('mp_costs_step_default') ||
              errors.has('mp_costs_step_4') ||
              errors.has('mp_costs_step_3') ||
              errors.has('mp_costs_step_2') ||
              errors.has('mp_costs_step_1') ||
              errors.has('country') ||
              errors.has('sales_channel_id') ||
              errors.has('valid_from')"
              class="btn btn-success"
              data-dismiss="modal"
              @click="clickedOk()"
              id="buttonOk"
            >
              {{ "confirm" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {translate} from "../../../filters";

export default {
  props: {
    loaded: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: 'EditFeesModal'
    },
    fee: {
      type: Object,
      default: () => {
        return false
      }
    },
    salesChannels: {
      type: Object,
      default: () => {
        return false
      }
    },
    editMode: {
      type: Boolean,
      default: true
    },
    company_name: {
      type: String,
      default: ''
    },
    creditorValue: {
      type: String,
      default: ''
    },
    validFromValueProp: {
      type: Date,
    }
  },
  data() {
    return {
      companyName: '',
      type: '',
      creditorNoValue: '',
      creditorNo: this.creditorValue,
      valid_from_error: '',
      validFromValue: this.validFromValueProp
    }

  },
  methods: {
    creditorValueKeyUp() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(this.checkForCreditorNo(this.creditorNoValue), 1000);
    },
    setOtherMps() {
      this.fee.mp_costs_step_4 = this.fee.mp_costs_step_default
      this.fee.mp_costs_step_3 = this.fee.mp_costs_step_default
      this.fee.mp_costs_step_2 = this.fee.mp_costs_step_default
      this.fee.mp_costs_step_1 = this.fee.mp_costs_step_default
    },
    creditorKeyUp() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(this.checkForCreditorNo(this.creditorNo), 1000);
      this.selectedDate();
    },
    checkForCreditorNo(value) {
      if (value.length === 0 || value.length < 10) {
        return
      }
      this.$emit('handleUpdate', value)
      this.selectedDate();
    },
    setType() {

      let type = this.salesChannels[this.fee.sales_channel_id]
      type = type.replace('schuhede-', '')
      type = type.charAt(0).toUpperCase() + type.slice(1)
      if (type === "Amazon") {
        this.fee.order_type = (type + '_' + this.fee.country).toUpperCase();
      } else {
        this.fee.order_type = "DEFAULT";
      }

      this.fee.type = type
      this.selectedDate();
    },
    selectedDate() {
      if (this.validFromValue == null) {
        this.validFromValue = this.fee.valid_from;
      }
      if (this.fee.id === undefined) {
        if (moment(this.validFromValue) > moment()) {
          this.valid_from_error = '';
          this.validFromValue = moment(this.validFromValue).toDate();
        } else {
          this.validFromValue = moment("2021-01-01").toDate();
          this.valid_from_error = "selected_date_must_be_in_future_will_reseted_to_jan_first_twentytwentyone";
        }
      } else {
        if (moment(this.fee.valid_from) > moment()) {
          if (moment(this.validFromValue) > moment()) {
            this.validFromValue = moment(this.validFromValue).toDate()
            this.valid_from_error = '';
          } else {

            this.validFromValue = moment(this.fee.valid_from).toDate();
            this.valid_from_error = "selected_date_must_be_in_future";
          }
        } else {
          this.validFromValue = moment(this.fee.valid_from).toDate();
          this.valid_from_error = "fee_valid_from_cannot_change";
        }
      }

      this.fee.valid_from = this.validFromValue;
      this.$forceUpdate();
    },
    clickedOk() {
      if (this.creditorNoValue.length > 0) {
        this.fee.creditorNo = this.creditorNoValue
      }

      if (this.creditorNo.length > 0) {
        this.fee.creditorNo = this.creditorNo
      }

      this.$validator.validate()
        .then(result => {
          if (result) {
            this.$emit('modalClicked', 'ok')
          }
        })
    }
  },
  watch: {
    creditorValue(value) {
      this.creditorNo = value;
    },

  },
  mounted() {
    this.validFromValue=this.fee.valid_from;
  },

  name: "EditFeesModal"

}
</script>

<style scoped>
@media (min-width: 768px) {
  .modal-dialog {
    width: 700px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tools/Modals/EditFeesModal.vue